import { useId, useState, type ReactNode } from 'react'

/**
 * "Your overview": the 1.9.6 Home, one level down under the mirror (Sprint
 * 1.9.9 D5).
 *
 * Expanded by default, so everything Home showed before is still on the first
 * screen that scrolls to it, with a Collapse control for someone who does not
 * want it. `hidden` rather than unmounting, so collapsing loses no loaded
 * state and expanding issues no request.
 */
export function Overview({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(true)
  const id = useId()
  return (
    <section className="overview subgrid" data-testid="home-overview" aria-labelledby={`${id}-title`}>
      <div className="overview__head">
        <h2 className="overview__title" id={`${id}-title`}>Your overview</h2>
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          aria-expanded={open}
          aria-controls={`${id}-body`}
          onClick={() => setOpen((was) => !was)}
        >
          {open ? 'Collapse' : 'Expand'}
        </button>
      </div>
      <div className="overview__body stack subgrid" id={`${id}-body`} hidden={!open}>
        {children}
      </div>
    </section>
  )
}
